import React, { useCallback, useLayoutEffect, useRef, useState } from 'react';
import clsx from 'clsx';
import { ScrollFadeContainer } from '../../../ScrollFadeContainer/ScrollFadeContainer.tsx';
import { Selector } from '../Selector/Selector.tsx';
import { useWheelScroll } from '../useWheelScroll.ts';
import styles from './LayoutHorizontal.module.scss';
import { prefersReducedMotion } from '../../../../utils/prefersReducedMotion.ts';
const FULL_WIDTH_PERCENT = 100;
export const LayoutHorizontal = ({ activeIndex, activeTabId, onTabChange, wheelScrollRef, tabPosition, tabs, variant })=>{
    const [isSliderAnimated, setIsSliderAnimated] = useState(false);
    const [isSliding, setIsSliding] = useState(false);
    const selectorRef = useRef(null);
    const panelScrollRefs = useRef([]);
    const panelWidthPercent = FULL_WIDTH_PERCENT / tabs.length;
    const sliderStyle = {
        width: `${tabs.length * FULL_WIDTH_PERCENT}%`,
        transform: `translateX(-${activeIndex * panelWidthPercent}%)`
    };
    const getScrollElement = useCallback(()=>{
        var _panelScrollRefs_current_activeIndex;
        return (_panelScrollRefs_current_activeIndex = panelScrollRefs.current[activeIndex]) !== null && _panelScrollRefs_current_activeIndex !== void 0 ? _panelScrollRefs_current_activeIndex : null;
    }, [
        activeIndex
    ]);
    useWheelScroll({
        containerRef: wheelScrollRef,
        selectorRef: selectorRef,
        getScrollElement: getScrollElement
    });
    useLayoutEffect(()=>setIsSliderAnimated(true), []);
    useLayoutEffect(()=>{
        const activePanel = panelScrollRefs.current[activeIndex];
        if (activePanel) activePanel.scrollTop = 0;
        if (!isSliderAnimated) return;
        if (prefersReducedMotion()) return;
        setIsSliding(true);
    }, [
        activeIndex
    ]);
    const handleTabClick = (tabId)=>onTabChange(tabId);
    const handleSlideEnd = (event)=>{
        if (event.target != event.currentTarget) return;
        setIsSliding(false);
    };
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Selector, {
        activeIndex: activeIndex,
        activeTabId: activeTabId,
        ref: selectorRef,
        onTabClick: handleTabClick,
        tabPosition: tabPosition,
        tabs: tabs,
        variant: variant
    }), /*#__PURE__*/ React.createElement("div", {
        className: clsx(styles.horizontalPanels, isSliding && styles.sliding)
    }, /*#__PURE__*/ React.createElement("div", {
        className: clsx(styles.panelsSlider, isSliderAnimated && styles.animated),
        style: sliderStyle,
        onTransitionEnd: handleSlideEnd
    }, tabs.map((tab, index)=>/*#__PURE__*/ React.createElement("div", {
            key: tab.props.id,
            className: styles.panel,
            style: {
                flex: `0 0 ${panelWidthPercent}%`
            },
            "aria-hidden": tab.props.id != activeTabId
        }, /*#__PURE__*/ React.createElement(ScrollFadeContainer, {
            ref: (el)=>{
                panelScrollRefs.current[index] = el;
            },
            direction: "vertical",
            hideScrollbar: isSliding
        }, /*#__PURE__*/ React.createElement("div", {
            className: styles.panelContent
        }, tab)))))));
};
